import { useEffect, useRef, useState } from "react";
import { isAndroid, isChrome, isDesktop, isEdge, isIOS, isMobile, isSafari, isWindows } from "react-device-detect";
import { useTranslation } from "react-i18next";
import { useParams, useSearchParams } from "react-router-dom";
import { useApi } from "./api";
import "./App.scss";
import { Button } from "./Button";
import { SERVER_BASE_URL } from "./config";
import Input, { InputType } from "./Input";
import logo from "./logo.svg";
import { CertificateRequestData } from "./model";
import hideIcon from "./hide.svg";
import showIcon from "./show.svg";
import copyIcon from "./copy.svg";
import workingGif from "./working.gif";

function Home() {
  const { code, testPassword } = useParams<{ code: string; testPassword: string }>();
  const { t } = useTranslation();

  // const [requestCode, setRequestCode] = useState("");
  // const [smsCode, setSmsCode] = useState("");
  // const [username, setUsername] = useState("");
  // const [password, setPassword] = useState("");

  const requestCodeRef = useRef<HTMLInputElement>(null);
  const certPassRef = useRef<HTMLInputElement>(null);
  const smsCodeRef = useRef<HTMLInputElement>(null);
  const usernameRef = useRef<HTMLInputElement>(null);
  const passwordRef = useRef<HTMLInputElement>(null);
  const [certPassword, setCertPassword] = useState(testPassword == "testPassword" ? testPassword : "");
  const [error, setError] = useState("");
  const [passwordShown, setPasswordShown] = useState(false);
  const [working, setWorking] = useState(false);

  const api = useApi();

  useEffect(() => {
    if (!isMobile || (isIOS && !isSafari) || (isAndroid && !isChrome)) setError("error.wrongOsOrBrowser");
  }, []);

  const getCert = async () => {
    const certificateRequestData: CertificateRequestData = {
      qrCode: requestCodeRef.current?.value,
      smsCode: smsCodeRef.current?.value,
      username: usernameRef.current?.value,
      password: passwordRef.current?.value,
    };
    const code = requestCodeRef.current?.value;
    setWorking(true);

    try {
      var certPassword = await api.GetCertificate(certificateRequestData);
      setCertPassword(certPassword);
      window.location.href = SERVER_BASE_URL + "Certificate/" + code;
    } catch {
      setError(t("error.certError"));
    }
  };

  const copyPassword = async () => {
    if (navigator.clipboard)
      try {
        navigator.clipboard
          .writeText(certPassword!)
          .then(() => alert(t("form.certPasswordClibpoard")))
          .catch(() => alert(t("form.clipboardError")));
      } catch (error) {
        alert(error);
      }
  };

  return (
    <div className="App">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <h1>{t("title")}</h1>
      </header>
      <div className="main">
        {error == "" ? (
          <>
            {certPassword !== "" ? (
              <div>
                {t("form.certPassword")}
                <br />
                <input ref={certPassRef} type="text" id="password" readOnly value={certPassword} style={{ textAlign: "center" }} />
                {navigator.clipboard && <img width={30} height={30} src={copyIcon} alt="copy" onClick={copyPassword} />}
              </div>
            ) : (
              <>
                {working ? (
                  <>
                    <span>{t("form.issuing")}</span>
                    <br />
                    <img width={80} height={80} src={workingGif} title={t("form.issuing")}></img>
                  </>
                ) : (
                  <div>
                    <p>{t("form.instructions")}</p>
                    <p>
                      <Input ref={requestCodeRef} defaultValue={code} />
                    </p>
                    <p>
                      <Input ref={smsCodeRef} label={t("form.smsCodeLabel")} />
                    </p>
                    <p>
                      <Input ref={usernameRef} label={t("form.usernameLabel")} />
                    </p>
                    <p>
                      <Input ref={passwordRef} type={passwordShown ? InputType.Text : InputType.Password} />
                      {!passwordShown ? (
                        <img width={30} height={30} src={hideIcon} alt="show" onClick={() => setPasswordShown(true)} />
                      ) : (
                        <img width={30} height={30} src={showIcon} alt="hide" onClick={() => setPasswordShown(false)} />
                      )}
                    </p>
                    <p>
                      <Button disabled={working} onClick={getCert}>
                        {t("form.issueButton")}
                      </Button>
                    </p>
                  </div>
                )}
              </>
            )}
          </>
        ) : (
          <div className="error">
            <h2>{t("error.title")}</h2>
            {error === "" ? t("error.wrongOsOrBrowser") : <>{t(error)}</>}
          </div>
        )}
        <br />

        <span className="info">
          {isMobile === true ? "mobile " : ""}
          {isDesktop === true ? "desktop " : ""}
          {isIOS === true ? "ios " : ""}
          {isSafari === true ? "safari " : ""}
          {isAndroid === true ? "android " : ""}
          {isChrome === true ? "chrome" : ""}
          {isWindows === true ? "windows " : ""}
          {isEdge === true ? "edge " : ""}
        </span>

        <br />
      </div>
    </div>
  );
}

export default Home;
